import Api from './Api';

export default {
    check(company, city, email) {
        return Api.get(`check/account?city=${city}&company=${company}&email=${email}`);
    },
    login(email, password) {
        return Api.post('/check/accountlogin', {email: email, password: password});
    }
}